"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportFileSchema = void 0;
const zod_1 = require("zod");
exports.exportFileSchema = zod_1.z.object({
    'editable-settings': zod_1.z.array(zod_1.z.record(zod_1.z.unknown())).optional(),
    'editable-pages': zod_1.z.array(zod_1.z.record(zod_1.z.unknown())).optional(),
    'configurable-lists': zod_1.z.array(zod_1.z.record(zod_1.z.unknown())).optional(),
    classifiers: zod_1.z.record(zod_1.z.array(zod_1.z.record(zod_1.z.unknown()))).optional(),
});
